import React from 'react';
import { Spinner } from 'reactstrap';
import InsightDetailModal from './InsightDetailModal';

/**
 * Panel lateral de insights de la última corrida.
 *
 * `insights = []` por defecto y los estados separados existen porque antes la
 * tarjeta mostraba "Aún no hay insights" en tres situaciones distintas: cuando
 * de verdad no hay, mientras cargaba, y cuando la petición fallaba. Las tres se
 * veían igual, así que un endpoint caído parecía simplemente falta de datos.
 */
const VISIBLE = 4;

const InsightsCard = ({ insights = [], isLoading = false, error = null }) => {
  const [selected, setSelected] = React.useState(null);
  // "Ver todos" no navega a otra pantalla: expande la lista acá mismo. Son
  // pocos insights por corrida, uno por tipo, así que una vista aparte sería
  // más ceremonia que valor.
  const [showAll, setShowAll] = React.useState(false);

  const visibleInsights = showAll ? insights : insights.slice(0, VISIBLE);

  return (
    <div className="ui-card">

      <div className="ui-card__head" style={{ marginBottom: 14 }}>
        <h3 className="ui-card__title">
          <i className="ri-lightbulb-line" style={{ color: '#D97706', fontSize: 18 }} />
          Insights automáticos
        </h3>
      </div>

      {isLoading && (
        <div className="d-flex align-items-center gap-2 ui-hint" style={{ marginTop: 0 }}>
          <Spinner size="sm" /> Cargando insights…
        </div>
      )}

      {!isLoading && error && (
        <div className="ui-note ui-note--danger">
          No se pudieron cargar los insights: {error.message || 'error desconocido'}
        </div>
      )}

      {!isLoading && !error && !insights.length && (
        <div className="ui-empty">Aún no hay insights de la última corrida.</div>
      )}

      {!isLoading && !error && insights.length > 0 && (
        <div className="d-flex flex-column gap-2">
          {visibleInsights.map((insight) => (
            <button
              key={insight.id}
              type="button"
              className="ui-tile text-start"
              style={{ cursor: 'pointer', width: '100%' }}
              onClick={() => setSelected(insight)}
            >
              <div className="ui-tile__body">{insight.text}</div>
              {insight.user && (
                <div className="ui-tile__meta">{insight.user}</div>
              )}
            </button>
          ))}
        </div>
      )}

      {!isLoading && !error && insights.length > VISIBLE && (
        <div className="d-flex justify-content-end mt-2">
          <button
            type="button"
            className="ui-link"
            onClick={() => setShowAll((value) => !value)}
          >
            {showAll ? 'Ver menos' : `Ver todos (${insights.length})`}
          </button>
        </div>
      )}

      <InsightDetailModal
        isOpen={Boolean(selected)}
        toggle={() => setSelected(null)}
        insight={selected}
      />
    </div>
  );
};

export default InsightsCard;
